module.exports = __webpack_public_path__ + "static/media/nepal.da61b9d9.svg";